import { useAppContext } from '../../appProvider/contextProvider';
import { useState, Suspense } from 'react';
import 'react-calendar/dist/Calendar.css';
import Map from '../../components/Map/Map';
import ReactTooltip from 'react-tooltip';
import roundOff from '../../Util/roundOff';
import { SubscriberGrowth, SubscriberLoader } from './SubscriberGrowth';
import { useMutation } from 'react-query';
import { cumulativeDashboard } from '../../services/userService';

const Dashboard = ({userKey}) => {

    const { selectedWebsite } = useAppContext();

    const [content, setContent] = useState('');
    const [inCumulativeMode, setCumulativeMode] = useState(false);

    const [cumulativeData, setCumulativeData] = useState(null);

    const getSubscribersPercent = (value) => {
        const websiteData = inCumulativeMode ? cumulativeData : selectedWebsite;
        if(websiteData?.subscriber_count === 0) return 0;
        return (Number(value) / Number(websiteData?.subscriber_count)) * 100
    }

    const getTop4Countries = () => {
        if(selectedWebsite) {
            return selectedWebsite?.subscribers_by_country.sort((a,b) => b.count - a.count).slice(0,5);
        }
        return [];
    }


    const getOtherBrowserCount = (browserName = 'others') => {
        const websiteData = inCumulativeMode ? cumulativeData : selectedWebsite;
        const data = websiteData?.subscribers_by_browser.find(({name}) => browserName === name);

        return data ? data.count : 0;    
    }

    const getPlatformCount = (browserName) => {
        if(inCumulativeMode) {
            const data = cumulativeData?.subscribers_by_platform.find(({name}) => browserName === name);
            return data ? data.count : 0;
        } else if(selectedWebsite) {
            const data =selectedWebsite?.subscribers_by_platform.find(({name}) => browserName === name);
            return data ? data.count : 0;
        }
        return 0;
    }


    const getCumulativeData = useMutation(() => cumulativeDashboard(), {
        onSuccess: (data) => {
            setCumulativeData(data)
            setCumulativeMode(true)
        },
    })

    const onSelectCumulativeDashboard = (event) => {
        event.preventDefault();
        if(!inCumulativeMode) {
            getCumulativeData.mutate();
        } else {
            setCumulativeMode(false);
        }
        
        
    }

    const getDataSource = () => {
        if(inCumulativeMode) {
            return cumulativeData;
        }
        return selectedWebsite;
    }


    return <> 
    {/* <div className="d-flex flex-wrap"><button className="btn"><i className="icon icon-refresh mr-2"></i> Refresh </button></div> */}
        <div className="full-height scrollable_y dashboard-container">
            {/* dropdown for websites for mobile view */}
            <div className='form-group d-flex justify-content-end' style={{padding: '0.875rem 0'}}>
                <h6 className='mb-0 medium mr-3'>Show Cumulative Dashboard</h6>
                <label className='toggle-control toggle-control-sm mb-2'>
                    <input type='checkbox' checked={inCumulativeMode} onChange={onSelectCumulativeDashboard} />
                    <span className='control'></span>
                </label>
            </div>
            <div className="row">
                <div className="col-12 col-md-6 col-xl-4">
                    <div className="card mb-3 feature-card">
                        <div className="media">
                            <div className="media_figure media_rounded" data-campaign-status="subscribers">
                                <div className="avatar">
                                    <i className="icon icon-subscriber icon-2x"></i>
                                </div>
                            </div>
                            <div className="media_body">
                                <h2 className="text-dark">{roundOff(getDataSource()?.subscriber_count)}</h2>
                                <p className="text-light">Subscribers</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-xl-4">
                    <div className="card mb-3 feature-card">
                        <div className="media">
                            <div className="media_figure media_rounded" data-campaign-status="sent">
                                <div className="avatar">
                                    <i className="icon icon-campaign-sent icon-2x"></i>
                                </div>
                            </div>
                            <div className="media_body">
                                <h2 className="text-dark">{roundOff(getDataSource()?.campaign_sent_count)}</h2>
                                <p className="text-light">Campaigns Sent</p>
                            </div>
                        </div>
                    </div>
                </div>                            
                <div className="col-12 col-md-6 col-xl-4">
                    <div className="card mb-3 feature-card">
                        <div className="media">
                            <div className="media_figure media_rounded" data-campaign-status="consumed">
                                <div className="avatar">
                                    <i className="icon icon-eye icon-2x"></i>
                                </div>
                            </div>
                            <div className="media_body">
                                <h2 className="text-dark">{roundOff(getDataSource()?.total_impression_count)}</h2>
                                <p className="text-light">Impressions</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-xl-4 d-block d-lg-none">
                    <div className="card mb-3">
                        <div className="media">
                            <div className="media_figure media_rounded" data-campaign-status="warning">
                                <div className="avatar">
                                    <i className="icon icon-subscriber icon-2x"></i>
                                </div>
                            </div>
                            <div className="media_body">
                                <h2>{roundOff(getDataSource()?.inactive_subscriber_count)}</h2>
                                <p className="text-light">Inactive Subscribers</p>
                            </div>
                        </div>
                    </div>   
                </div>
            </div>
            {
                !inCumulativeMode && <div className="d-flex flex-wrap">
                <Suspense fallback={<SubscriberLoader />}>
                    <SubscriberGrowth />
                </Suspense>
            </div>}
            <div className="row mt-3">
                        <div className="col-12 col-lg-6 mb-3">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <h5 className="medium mb-0">Top 4 - Map</h5>
                                    <p className="text-light"><small>of subscribers by country of origin</small></p>
                                </div>
                                <div className="card-body">
                                    <table className="table table-hover map-table full-width">
                                        <colgroup width="100%">
                                            <col width="40%"/>
                                            <col width="60%"/>
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>Country</th>
                                                <th>Subscribers</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            getTop4Countries().map((subscribersDetail, index) => <tr key={index} >
                                                <td>{subscribersDetail.name}</td>
                                                <td>{roundOff(subscribersDetail.count)}</td>
                                            </tr>)
                                        }
                                        </tbody>
                                    </table>
                                    {
                                        Object.entries(getDataSource()?.subscribers_by_country || {}).length <=0 && <div className="maps-no-data">
                                            No Data Found
                                        </div>
                                    }
                                    <div className="map-container">
                                        {/* <img src="images/map.svg" alt=""/> */}
                                        <Map subscribersByCountry={getDataSource()?.subscribers_by_country} setTooltipContent={setContent} />
                                        <ReactTooltip>{content}</ReactTooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 mb-3">
                            <div className="d-flex flex-column">
                                <div className="card mb-3">
                                    <div className="card-header">
                                        <h5 className="medium mb-0">Platforms</h5>
                                        <p className="text-light"><small>usage among your subscribers</small></p>
                                    </div>
                                    <div className="card-body">
                                        <div className="mb-5 mt-4">
                                            <label>Mozila Firefox ({parseFloat(getSubscribersPercent(getOtherBrowserCount('firefox'))).toFixed(2)}%)</label>
                                            <div className="progress">
                                            <div className="progress-bar bg-mozilla" role="progressbar" style={{'width': `${getSubscribersPercent(getOtherBrowserCount('firefox'))}%`}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>    
                                        </div>   
                                        <div className="mb-5">
                                            <label>Google Chrome ({parseFloat(getSubscribersPercent(getOtherBrowserCount('chrome'))).toFixed(2)}%)</label>
                                            <div className="progress">
                                            <div className="progress-bar bg-chrome" role="progressbar" style={{'width': `${getSubscribersPercent(getOtherBrowserCount('chrome'))}%`}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>    
                                        </div>    
                                        <div className="mb-5">
                                            <label>Apple Safari ({parseFloat(getSubscribersPercent(getOtherBrowserCount('safari'))).toFixed(2)} %)</label>
                                            <div className="progress">
                                            <div className="progress-bar bg-apple" role="progressbar" style={{'width': `${getSubscribersPercent(getOtherBrowserCount('safari'))}%`}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>    
                                        </div>
                                    
                                        <div className="mb-5">
                                            <label>Other Browsers ({parseFloat(getSubscribersPercent(getOtherBrowserCount())).toFixed(2)} %)</label>
                                            <div className="progress">
                                            <div className="progress-bar bg-mozilla" role="progressbar" style={{'width': `${getSubscribersPercent(getOtherBrowserCount())}%`}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>      
                                        </div>
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between">
                                                <h6 className="text-desktop">Desktop ({parseFloat(getSubscribersPercent(getPlatformCount('desktop'))).toFixed(2)}%)</h6>
                                                <h6 className="text-mobile">Mobile ({parseFloat(getSubscribersPercent(getPlatformCount('mobile'))).toFixed(2)}%)</h6>
                                                <h6 className="text-tablet">Tablet ({parseFloat(getSubscribersPercent(getPlatformCount('tablet'))).toFixed(2)}%)</h6>
                                            </div>
                                            <div className="progress">
                                                <div className="progress-bar bg-desktop" role="progressbar" style={{'width': `${getSubscribersPercent(getPlatformCount('desktop'))}%`}} aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>
                                                <div className="progress-bar bg-mobile" role="progressbar" style={{'width': `${getSubscribersPercent(getPlatformCount('mobile'))}%`}} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                                <div className="progress-bar bg-tablet" role="progressbar" style={{'width': `${getSubscribersPercent(getPlatformCount('tablet'))}%`}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>                                            
                                        </div>                                            
                                    </div>
                                </div>
                                <div className="card mb-3 d-none d-md-block">
                                    <div className="media">
                                        <div className="media_figure media_rounded" data-campaign-status="warning">
                                            <div className="avatar">
                                                <i className="icon icon-subscriber icon-2x"></i>
                                            </div>
                                        </div>
                                        <div className="media_body">
                                            <h2>{roundOff(getDataSource()?.inactive_subscriber_count)}</h2>
                                            <p className="text-light">Inactive Subscribers</p>
                                        </div>
                                    </div>
                                </div>                                    
                            </div>
                        </div>
                    </div>
        </div>
    </>
};


export default Dashboard;